<template>
  <div class="popup-overlay" v-if="active"></div>
  <div class="popup" v-if="active">
    <div class="popup__success">
      <!--      <div>-->
      <!--        <img src="../../assets/img/success.svg" alt="" style="width:135px;">-->
      <!--      </div>-->

      <div class="popup__title">
        {{ translate('Auth.hi_message', { name: currentUser?.name }) }},
      </div>
      <div class="popup__text">
        {{ trans('Auth.successfully_login1') }}
        <br />
        {{ trans('Auth.successfully_login2') }}
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import { trans, translate } from '@/common/language/translations';

import { computed, defineComponent } from 'vue';
import useAuthStore from '@/store/auth';
import { IUser } from '@/declare/types/user';

export default defineComponent({
  name: 'PaymentRequired',
  setup() {
    const authStore = useAuthStore();
    const currentUser = authStore.currentUser as IUser;
    const currentBusiness = authStore.currentBusiness;
    const active = computed(() => false);
    // todo: implement missing billing logic
    return {
      currentUser,
      currentBusiness,
      active,
      translate,
      trans
    };
  }
});
</script>

<style scoped></style>
